"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORTED_COMPARISON_TYPES = void 0;
exports.toCompareValue = toCompareValue;
exports.SUPPORTED_COMPARISON_TYPES = [
    "string",
    "number",
    "boolean",
    "undefined",
];
function toCompareValue(value) {
    switch (typeof value) {
        case "string":
            return value;
        case "number":
            return String(value);
        case "boolean":
            return value ? "1" : "0";
        default:
            return "";
    }
}
//# sourceMappingURL=comparison.js.map